// modules
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// imports
import { Container } from './container.directive';

// exports
export {
  Container
};

@NgModule({
  declarations: [
    Container,
  ],
  exports: [
    Container,
  ],
  imports: [
    CommonModule,
  ]
})
export class ContainerModule { }
